import { gql } from '@apollo/client'

export const standardsLanguages = gql`
  query StandardsLanguages($langOverride: String) {
    standardsLanguages(langOverride: $langOverride) {
      code
      language
    }
  }
`
